// ─────────────────────────────────────────────────────────────
// lib/supabase.js — the SB Training Hub's Supabase client
// ─────────────────────────────────────────────────────────────
// Shared OA project (rfzztndieqiixcauxdvj), same sign-in as every other OA
// module (OA Auth Task 09). The anon key is public; every table is RLS-gated.
// Create React App build: the values are plain constants, so no
// REACT_APP_* env variables are needed (same as the other hubs).
import { initOaAuth } from "./oaAuth";

export const SUPABASE_URL = "https://rfzztndieqiixcauxdvj.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJmenp0bmRpZXFpaXhjYXV4ZHZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc5MDIyNzYsImV4cCI6MjA5MzQ3ODI3Nn0.N7WByLEE_VhdBaFoOctIygXhrkAdCiK4XoVUqRJwFvU";

// Cookie session shared by every *.obviousadvantage.ca module — see ./oaAuth.js.
export const supabase = initOaAuth(SUPABASE_URL, SUPABASE_ANON_KEY);
